import { render, staticRenderFns } from "./import-self.vue?vue&type=template&id=9e884786&scoped=true"
import script from "./import-self.vue?vue&type=script&lang=js"
export * from "./import-self.vue?vue&type=script&lang=js"
import style0 from "./import-self.vue?vue&type=style&index=0&id=9e884786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e884786",
  null
  
)

export default component.exports